import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getDashboardData } from '../slice/contactUsSlice';
import { RiMedicineBottleLine } from "react-icons/ri";
import CountUp from 'react-countup';
import { FaUser, FaNutritionix, FaAdjust, FaUserAltSlash, FaAddressCard } from "react-icons/fa";
// import MonthSalesChart from 'common/chart/MonthSalesChart';
import SalesChart from 'common/chart/SalesChart';
import ProductSalesChart from 'common/chart/ProductSalesChart';
import CustomerAllOrder from './orderList/CustomerAllOrder';



function Home() {
  const dispatch = useDispatch()
  const Data = useSelector((state) => state.contactus);

  const { table_counts } = Data.data;
  useEffect(() => {
    dispatch(getDashboardData())
  }, [dispatch])


  return (
    <>
      <div className="container-fluid px-lg-5 mt-5">
        <div className="d-sm-flex align-items-center justify-content-between mb-2 mainheadig rounded">
          <h1 className="h3 mb-0 text-white">Dashboard</h1>
        </div>
        <div className="row mt-3">
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="card border-left-primary shadow h-100 py-2 dashboard-card">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                      Total Services</div>
                    <div className="h5 mb-0 font-weight-bold text-gray-800"> <CountUp end={table_counts?.product} duration={2} /></div>
                  </div>
                  <div className="col-auto">
                    <RiMedicineBottleLine className='fa-2x text-gray-300' />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="card border-left-warning shadow h-100 py-2 dashboard-card">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="text-xs font-weight-bold text-warning text-uppercase mb-1">
                      Total Category</div>
                    <div className="h5 mb-0 font-weight-bold text-gray-800">  <CountUp end={table_counts?.category} duration={4} /></div>
                  </div>
                  <div className="col-auto">
                    <FaUser className='fa-2x text-gray-300' />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="card border-left-success shadow h-100 py-2 dashboard-card">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                      Total  Servicesmen</div>
                    <div className="h5 mb-0 font-weight-bold text-gray-800"> <CountUp end={table_counts?.servicemen} duration={6} /></div>
                  </div>
                  <div className="col-auto">
                    <FaUserAltSlash className='fa-2x text-gray-300' />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="card border-left-danger shadow h-100 py-2 dashboard-card">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="text-xs font-weight-bold text-danger text-uppercase mb-1">
                      Total Orders</div>
                    <div className="h5 mb-0 font-weight-bold text-gray-800"> <CountUp end={table_counts?.ordercount} duration={8} /></div>
                  </div>
                  <div className="col-auto">
                    <FaNutritionix className='fa-2x text-gray-300' />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="card border-left-success shadow h-100 py-2 dashboard-card">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                      Total Customers</div>
                    <div className="h5 mb-0 font-weight-bold text-gray-800"> <CountUp end={table_counts?.customer} duration={10} /></div>
                  </div>
                  <div className="col-auto">
                    <FaAdjust className='fa-2x text-gray-300' />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="card border-left-success shadow h-100 py-2 dashboard-card">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                      Total  Contactus</div>
                    <div className="h5 mb-0 font-weight-bold text-gray-800"> <CountUp end={table_counts?.contactus} duration={6} /></div>
                  </div>
                  <div className="col-auto">
                    <FaAddressCard className='fa-2x text-gray-300' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h3 className="my-5 heading-sales">Sales Overview</h3>

        {/* <MonthSalesChart
          title="FY 2025 Month-Wise Sales (₹)"
          type="column"   // try "line" too
          height={440}
        /> */}
        <SalesChart />

        <div className='my-5'>
          <ProductSalesChart />

        </div>



    

      </div>
        <CustomerAllOrder/>

    </>
  )
}

export default Home